import moment from 'moment'

export const formatDate = (dateString) => {
    return moment(new Date(dateString)).format("DD/MM/YYYY");
}

export const formatTime = (timeString) => {
    return moment(timeString, "HH:mm").format("hh:mm A");
}

export const formatDisplayDate = (dateString) => {
    return moment(dateString,["DD/MM/YYYY","YYYY-MM-DD"]).format("MMM DD, YYYY");

}
